module.exports = __webpack_public_path__ + "img/Content.43b994c4.png";